import theme from '@styles/theme';
import reusables from '@styles/theme/reusables';
export default {
  paginationContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: ['41px 16px 16px', '41px 16px 16px', '41px 0']
  },
  seeMoreButton: {
    height: '36px',
    cursor: 'pointer',
    textDecoration: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: `1px solid ${theme.rawColors.darkGrey700}`,
    fontFamily: theme.fonts.uniform,
    fontSize: theme.fontSizes.h5,
    letterSpacing: theme.letterSpacings.caps,
    color: theme.rawColors.darkGrey700,
    backgroundColor: 'transparent',
    ...reusables.mainTransition('color,border-color,background-color', 'cubic-bezier(0, 0, 0.6, 1)', '.5s'),
    '&:hover': {
      color: theme.rawColors.neutralWhite,
      backgroundColor: theme.rawColors.neutralBlack
    },
    '&:active': {
      color: theme.rawColors.darkGrey700,
      backgroundColor: 'transparent'
    },
    span: {
      padding: '0 24px'
    }
  }
};